(function () {
  'use strict';

  var STOPS = [
    { at: 0.0, rgb: [251, 249, 242] },
    { at: 0.34, rgb: [228, 239, 238] },
    { at: 0.67, rgb: [247, 236, 216] },
    { at: 1.0, rgb: [237, 228, 214] },
  ];

  var MQ = '(min-width: 900px)';
  var REDUCE = '(prefers-reduced-motion: reduce)';
  var MOBILE_PER_STEP = 0.5;

  function clamp(n, a, b) {
    return Math.min(b, Math.max(a, n));
  }

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function colourAt(p) {
    var i = 0;
    while (i < STOPS.length - 1 && STOPS[i + 1].at < p) i++;
    var a = STOPS[i];
    var b = STOPS[Math.min(i + 1, STOPS.length - 1)];
    var span = b.at - a.at || 1;
    var t = clamp((p - a.at) / span, 0, 1);
    return [
      Math.round(lerp(a.rgb[0], b.rgb[0], t)),
      Math.round(lerp(a.rgb[1], b.rgb[1], t)),
      Math.round(lerp(a.rgb[2], b.rgb[2], t)),
    ];
  }

  function initSection(root) {
    var track = root.querySelector('[data-hw-track]');
    var stage = root.querySelector('[data-hw-stage]');
    var bg = root.querySelector('[data-hw-bg]');
    var cardsEl = root.querySelector('[data-hw-cards]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.hw__card'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hw-dots] li'));
    if (!track || !stage || !cardsEl || !cards.length) return;

    root.classList.add('hw--enhanced');

    var enablePin = root.getAttribute('data-hw-enable-pin') !== 'false';
    var perStep = parseFloat(root.getAttribute('data-hw-per-step') || '0.62');
    if (isNaN(perStep)) perStep = 0.62;
    perStep = clamp(perStep, 0.45, 0.75);

    var STEPS = cards.length;
    var mqDesktop = window.matchMedia(MQ);
    var mqReduce = window.matchMedia(REDUCE);

    var intersecting = false;
    var rafId = 0;
    var loopOn = false;
    var resizeTimer = 0;
    var lastActive = -1;
    var lastColour = '';

    function canPin() {
      return enablePin && !mqReduce.matches;
    }

    function stepMultiplier() {
      return mqDesktop.matches ? perStep : MOBILE_PER_STEP;
    }

    function stickyBarOffset() {
      if (mqDesktop.matches) return 0;
      var bar = document.querySelector('.ted-sp__sticky.is-on:not([hidden])');
      return bar ? bar.getBoundingClientRect().height : 0;
    }

    function measureCardsViewport() {
      if (!canPin() || mqDesktop.matches) {
        cardsEl.style.maxHeight = '';
        return;
      }

      window.requestAnimationFrame(function () {
        var dotsEl = root.querySelector('.hw__dots');
        var cardsTop = cardsEl.getBoundingClientRect().top;
        var bottomLimit = dotsEl
          ? dotsEl.getBoundingClientRect().top
          : stage.getBoundingClientRect().bottom - stickyBarOffset();
        var available = bottomLimit - cardsTop - 6;
        cardsEl.style.maxHeight = Math.max(148, Math.floor(available)) + 'px';
      });
    }

    function measureTallest() {
      if (!canPin()) {
        cardsEl.style.minHeight = '';
        return;
      }
      cardsEl.style.minHeight = '';
      var restoreActive = lastActive < 0 ? 0 : lastActive;
      var maxH = 0;

      root.classList.add('hw--measuring');
      /* Lock to tallest in-sequence stack (past titles + one open body). */
      for (var i = 0; i < cards.length; i++) {
        setCards(i);
        maxH = Math.max(maxH, cardsEl.getBoundingClientRect().height);
      }
      root.classList.remove('hw--measuring');

      setCards(restoreActive);
      lastActive = restoreActive;
      cardsEl.style.minHeight = Math.ceil(maxH) + 'px';
      measureCardsViewport();
    }

    function layout() {
      if (!canPin()) {
        track.style.height = '';
        cardsEl.style.minHeight = '';
        cardsEl.style.maxHeight = '';
        return;
      }
      var h = window.innerHeight;
      track.style.height = h + STEPS * stepMultiplier() * h + 'px';
      measureTallest();
      measureCardsViewport();
    }

    function progress() {
      var r = track.getBoundingClientRect();
      var total = track.offsetHeight - window.innerHeight;
      if (total <= 0) return 0;
      return clamp(-r.top / total, 0, 1);
    }

    function setCards(active) {
      for (var i = 0; i < cards.length; i++) {
        var el = cards[i];
        var on = i === active;
        el.classList.toggle('is-active', on);
        el.classList.toggle('is-past', i < active);
        var row = el.querySelector('.hw__row');
        if (row) {
          row.setAttribute('aria-expanded', on ? 'true' : 'false');
          row.setAttribute('tabindex', on || i < active ? '0' : '-1');
        }
        var links = el.querySelectorAll('a.hw__link');
        for (var L = 0; L < links.length; L++) {
          if (on) links[L].removeAttribute('tabindex');
          else links[L].setAttribute('tabindex', '-1');
        }
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-on', d <= active);
      }

      setMobileLayout(active);
    }

    function setMobileLayout(active) {
      if (mqDesktop.matches || !canPin()) {
        root.classList.remove('hw--product-hidden');
        return;
      }

      root.classList.toggle('hw--product-hidden', active >= 1);
      measureCardsViewport();
    }

    function scrollToStep(index) {
      index = clamp(index, 0, STEPS - 1);

      if (!canPin()) {
        var card = cards[index];
        if (card) {
          card.scrollIntoView({
            behavior: mqReduce.matches ? 'auto' : 'smooth',
            block: 'nearest',
          });
        }
        return;
      }

      layout();
      var total = track.offsetHeight - window.innerHeight;
      if (total <= 0) return;

      var p = index >= STEPS - 1 ? 1 : (index + 0.5) / STEPS;
      var targetScroll = track.offsetTop + p * total;

      window.scrollTo({
        top: targetScroll,
        behavior: mqReduce.matches ? 'auto' : 'smooth',
      });

      lastActive = index;
      setCards(index);
      setColour(p);
      setProduct(p);
    }

    function bindStepTriggers() {
      for (var i = 0; i < cards.length; i++) {
        (function (idx) {
          var row = cards[idx].querySelector('.hw__row');
          if (!row || row.getAttribute('data-hw-bound') === 'true') return;
          row.setAttribute('data-hw-bound', 'true');
          row.setAttribute('role', 'button');

          function activate(e) {
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
            if (e.type === 'keydown') e.preventDefault();
            scrollToStep(idx);
          }

          row.addEventListener('click', activate);
          row.addEventListener('keydown', activate);
        })(i);
      }
    }

    bindStepTriggers();

    function bindPinnedSectionWheel() {
      if (!stage || stage.getAttribute('data-hw-wheel-bound') === 'true') return;
      stage.setAttribute('data-hw-wheel-bound', 'true');

      stage.addEventListener(
        'wheel',
        function (event) {
          if (!canPin() || !loopOn) return;

          var absX = Math.abs(event.deltaX);
          var absY = Math.abs(event.deltaY);
          if (absY <= absX) return;

          var inCards = cardsEl && cardsEl.contains(event.target);

          // Desktop cards column: native page scroll already drives the pin sequence.
          if (inCards && mqDesktop.matches) return;

          // Mobile cards: only consume vertical wheel while inner content still scrolls.
          if (inCards && !mqDesktop.matches) {
            var maxScroll = cardsEl.scrollHeight - cardsEl.clientHeight;
            if (maxScroll > 1) {
              if (event.deltaY > 0 && cardsEl.scrollTop < maxScroll - 1) return;
              if (event.deltaY < 0 && cardsEl.scrollTop > 0) return;
            }
          }

          event.preventDefault();
          window.scrollBy(0, event.deltaY);
        },
        { passive: false, capture: true }
      );
    }

    bindPinnedSectionWheel();

    function setColour(p) {
      var rgb = colourAt(p);
      var css = 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
      if (css === lastColour) return;
      lastColour = css;
      if (bg) bg.style.backgroundColor = css;
    }

    function setProduct(p) {
      if (mqDesktop.matches) {
        stage.style.setProperty('--rot', -6 + p * 26 + 'deg');
        stage.style.setProperty('--scale', (1.02 + p * 0.2).toFixed(3));
        stage.style.setProperty('--ty', p * -6 + '%');
      } else {
        stage.style.setProperty('--rot', -3 + p * 12 + 'deg');
        stage.style.setProperty('--scale', (0.9 + p * 0.1).toFixed(3));
        stage.style.setProperty('--ty', p * -2 + '%');
      }
    }

    function tick() {
      rafId = 0;
      if (!loopOn || !canPin()) return;

      var p = progress();
      var f = p * STEPS;
      var active = Math.min(STEPS - 1, Math.floor(f));
      if (p >= 1) active = STEPS - 1;

      setColour(p);
      setProduct(p);

      if (active !== lastActive) {
        lastActive = active;
        setCards(active);
        if (!mqDesktop.matches) {
          cardsEl.scrollTop = 0;
        }
      }
    }

    function requestTick() {
      if (!rafId && loopOn) {
        rafId = requestAnimationFrame(tick);
      }
    }

    function onScroll() {
      if (!loopOn) return;
      if (!rafId) rafId = requestAnimationFrame(tick);
    }

    function startLoop() {
      if (loopOn || !canPin()) return;
      loopOn = true;
      layout();
      lastActive = -1;
      requestTick();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    function stopLoop() {
      if (!loopOn) return;
      loopOn = false;
      window.removeEventListener('scroll', onScroll);
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = 0;
      }
    }

    function resetStatic() {
      stopLoop();
      root.classList.remove('hw--pin');
      track.style.height = '';
      cardsEl.style.minHeight = '';
      cardsEl.style.maxHeight = '';
      lastColour = '';
      if (bg) bg.style.backgroundColor = '';
      stage.style.removeProperty('--rot');
      stage.style.removeProperty('--scale');
      stage.style.removeProperty('--ty');
      root.classList.remove('hw--product-hidden');
      for (var i = 0; i < cards.length; i++) {
        cards[i].classList.remove('is-active', 'is-past');
        var row = cards[i].querySelector('.hw__row');
        if (row) {
          row.removeAttribute('aria-expanded');
          row.removeAttribute('tabindex');
          row.removeAttribute('role');
        }
        var links = cards[i].querySelectorAll('a.hw__link');
        for (var L = 0; L < links.length; L++) {
          links[L].removeAttribute('tabindex');
        }
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.remove('is-on');
      }
      lastActive = -1;
    }

    function syncMode() {
      if (canPin()) {
        root.classList.add('hw--pin');
        layout();
        setCards(lastActive < 0 ? 0 : lastActive);
        if (lastActive < 0) lastActive = 0;
        if (intersecting) startLoop();
        else stopLoop();
      } else {
        resetStatic();
      }
    }

    var io = new IntersectionObserver(
      function (entries) {
        intersecting = entries.some(function (e) {
          return e.isIntersecting;
        });
        if (!canPin()) return;
        if (intersecting) startLoop();
        else stopLoop();
      },
      { root: null, threshold: 0 }
    );
    io.observe(track);

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        syncMode();
        measureCardsViewport();
        if (loopOn) requestTick();
      }, 150);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (loopOn && !mqDesktop.matches) measureCardsViewport();
      },
      { passive: true }
    );

    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize, { passive: true });

    if (typeof mqDesktop.addEventListener === 'function') {
      mqDesktop.addEventListener('change', syncMode);
      mqReduce.addEventListener('change', syncMode);
    } else if (typeof mqDesktop.addListener === 'function') {
      mqDesktop.addListener(syncMode);
      mqReduce.addListener(syncMode);
    }

    layout();
    syncMode();
  }

  function boot() {
    var sections = document.querySelectorAll('[data-hw]');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el =
      event.target && event.target.querySelector
        ? event.target.querySelector('[data-hw]') ||
          (event.target.matches && event.target.matches('[data-hw]') ? event.target : null)
        : null;
    if (el) initSection(el);
  });
})();
